import BaseClass from "../BaseClass.js";

export default class PageReloader extends BaseClass {

    constructor(element) {
        super(element);

        this.containerRemovedListener = null;

        this.init();
    }

    init() {
        let mySelf = this;
        let autoloadElements = mySelf.$element.find('[data-autoload-element]');

        if (autoloadElements.length > 0) {
            this.containerRemovedListener = function (event, data) {
                mySelf.checkElements(event, data);
            }
            $(document).on('container:removed', this.containerRemovedListener);
        }
    }

    checkElements() {
        let mySelf = this;
        let autoloadElements = mySelf.$element.find('[data-autoload-element]');

        if (0 == autoloadElements.length) {
            window.location.replace(window.location.href);
        }
    }

    destroyListener() {
        if (this.containerRemovedListener != null) {
            $(document).off('container:removed', this.containerRemovedListener);
        }
    }
}